import { render, staticRenderFns } from "./TeachRoomDesign.vue?vue&type=template&id=6edecd5a&scoped=true&"
import script from "./TeachRoomDesign.vue?vue&type=script&lang=js&"
export * from "./TeachRoomDesign.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomDesign.vue?vue&type=style&index=0&id=6edecd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edecd5a",
  null
  
)

export default component.exports